import React, { useEffect, useState } from "react";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useStore } from "../../store";
import {
  deleteOrganizations,
  getHospitals,
  getOrganizations,
  locationsList,
  updateOrganizations,
} from "../../lib/api";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { cn } from "../../shared/utils";
import { DeleteIcon, SearchIcon } from "../../shared/svgIcon";
import { Dialog, DialogContent } from "../ui/dialog";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alertDialog";

const AddFacilityPage = () => {
  let navigate = useNavigate();
  const queryClient = useQueryClient();
  const selectedPatient = useStore((state) => state.patient);
  const [selectedLocation, setSelectedLocation] = useState("all");
  const [searchHospital, setSearchHospital] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [selectedHospitals, setSelectedHospital] = useState([]);
  const [tempSelectedHospital, setTempSelectedHospital] = useState([]);

  const {
    data: selectedHospitalListRes,
    isLoading: isLoadingHospital,
    dataUpdatedAt,
  } = useQuery({
    queryKey: ["selectedHospitalList"],
    queryFn: () => getOrganizations(selectedPatient?.id),
    enabled: !!selectedPatient?.id,
    refetchOnMount: true,
  });

  useEffect(() => {
    const currentHospitals =
      selectedHospitalListRes?.data?.result?.map((e) => ({
        ...e.organization,
        isActive: true,
      })) || [];
    console.log(currentHospitals, "currentHospitals");
    setSelectedHospital([...currentHospitals]);
    setTempSelectedHospital([...currentHospitals]);
  }, [dataUpdatedAt, selectedHospitalListRes]);

  const { data: locationListRes } = useQuery({
    queryKey: ["getLocation"],
    queryFn: () => locationsList(),
    refetchOnMount: false,
    staleTime: 15 * (60 * 1000),
  });
  const locations = locationListRes?.data?.result || [];

  const { data: hospitalListRes, isLoading } = useQuery({
    queryKey: ["hospitalList", selectedLocation, searchHospital],
    queryFn: () =>
      getHospitals({
        location: selectedLocation == "all" ? "" : selectedLocation,
        name: searchHospital,
      }),
    enabled: !!selectedLocation,
  });
  const hospitalList = hospitalListRes?.data?.result || [];
  const handleSearchChange = (event) => {
    const { value } = event.target;
    setSearchHospital(value);
  };

  const handleLocationChange = async (event) => {
    const location = event.target.value;
    setSelectedLocation(location);
  };

  const handleHospitalClick = (hospital) => {
    const isSelected = tempSelectedHospital?.some(
      (selected) => selected.id === hospital.id
    );
    if (isSelected) {
      const isActive = tempSelectedHospital?.filter(
        (selected) => selected.id === hospital.id
      )[0].isActive;
      if (isActive) return;
    }

    const updatedHospital = isSelected
      ? tempSelectedHospital?.filter((selected) => selected.id !== hospital.id)
      : [...tempSelectedHospital, hospital];
    console.log(updatedHospital, "updatedHospital");
    setTempSelectedHospital(updatedHospital);
  };

  const updateHospitals = () => {
    setSelectedHospital([...tempSelectedHospital]);
    setIsDialogOpen(false);
  };

  const deleteOrg = useMutation({
    mutationFn: (deletedOrgPayload) =>
      deleteOrganizations(selectedPatient?.id, deletedOrgPayload),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["selectedHospitalList"] }),
  });
  const updateOrg = useMutation({
    mutationFn: (updatedOrgPayload) =>
      updateOrganizations(selectedPatient?.id, updatedOrgPayload),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["selectedHospitalList"] }),
  });
  const handleSubmit = async (itemId) => {
    const payload = {
      organizations: selectedHospitals.map((e) => e?.id) || [],
    };
    updateOrg.mutate(payload);
    // const res = await updateOrganizations(selectedPatient?.id, itemId);
    // console.log(res, "updateOrganizations");
  };
  const onDelete = (item) => {
    deleteOrg.mutate(item?.id);
  };
  const handleDelete = async (deleteItem) => {
    setDeleteItem(deleteItem);
    const isActive = selectedHospitals?.filter(
      (selected) => selected.id === deleteItem.id
    )[0].isActive;
    if (isActive) {
      setShowDeleteConfirm(true);
    } else {
      const updateItem = selectedHospitals.filter((e) => e.id != deleteItem.id);
      setSelectedHospital([...updateItem]);
    }
  };
  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <div className="bg-white min-sh-screen">
      <>
        {" "}
        <div className="flex justify-between text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-white ">
          <div>
            <Link className="flex" onClick={handleGoBack}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                />
              </svg>
              <div className="pl-2 flex-1 mt-0.5">
                <h4 className="font-semibold text-base">Hospital/Facility</h4>
              </div>
            </Link>
          </div>

          <button
            onClick={() => setIsDialogOpen(true)}
            className={cn(
              "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
              "bg-primary text-primary-foreground shadow hover:opacity-[.75]",
              "h-9 px-4 py-2"
            )}
          >
            <span className="mr-1 text-lg leading-none">+</span>
            Add
          </button>
        </div>
        <div className=" flex-1 h-[calc(100vh-70px)] overflow-scroll hideScroll  text-gray-500  flex flex-col pt-20  pb-4 px-4">
          {selectedHospitals.length > 0 && !isLoading && (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 flex-wrap  ">
              {selectedHospitals.map((hospital, index) => (
                <div
                  className={`flex relative flex-1 items-start space-x-3 py-4 px-2 bg-[#F5F5F5] text-[#32365C] rounded-[18px] border shadow cursor-pointer `}
                  key={index}
                  onClick={(e) => {
                    handleHospitalClick(hospital);
                  }}
                >
                  <div className="flex flex-col">
                    <div className="relative w-full">
                      <img
                        src={hospital?.logo_url}
                        alt={hospital?.name}
                        className="h-12 object-contain"
                      />
                    </div>
                    <h1 className="text-gray-700 font-medium leading-none">
                      {hospital.name}
                    </h1>
                    <p className="text-xs text-gray-500 mt-2 leading-4">
                      <span className="pr-2">{hospital?.address?.street},</span>
                      <span className="pr-2">{hospital?.address?.city},</span>
                      <span className="pr-2">{hospital?.address?.state}</span>
                      <span className="pr-2">
                        {hospital?.address?.postal_code}
                      </span>
                    </p>
                  </div>
                  <div
                    className="absolute  leading-none right-4 cursor-pointer"
                    onClick={() => handleDelete(hospital)}
                  >
                    <DeleteIcon />
                  </div>
                </div>
              ))}
            </div>
          )}
          {selectedHospitals?.length == 0 && !isLoading && (
            <h1 className="mt-3 px-2">No Hospitals found</h1>
          )}
        </div>
        <div
          className="bg-white h-16 fixed bottom-0 w-full flex justify-center"
          onClick={handleSubmit}
        >
          <button className="  w-11/12 h-14 p-3 bg-blue-800 rounded-[18px] text-white font-semibold">
            Submit
          </button>
        </div>
      </>
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="sm:max-w-[60%] max-w-[90%]">
          <div className="grid mt-4  gap-2 relative">
            <div className="flex flex-col justify-end  w-full sm:w-1/3 ">
              <select
                id="location"
                className={cn(
                  "flex    w-full items-center justify-between rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm  placeholder:text-muted-foreground focus:outline-none  disabled:cursor-not-allowed disabled:opacity-50",
                  "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg "
                )}
                value={selectedLocation}
                onChange={handleLocationChange}
              >
                <option value="all">All Location</option>
                {locations.map((location, index) => (
                  <option key={index} value={location} className="">
                    {location}
                  </option>
                ))}
              </select>
            </div>
            <div className="mt-4 relative">
              <SearchIcon className="absolute left-2 top-3 h-4 w-4 text-muted-foreground" />
              <input
                className="w-full  pl-8 h-10 bg-neutral-100 rounded-[18px] border"
                type="text"
                placeholder="Search hospital/facility"
                value={searchHospital}
                onChange={handleSearchChange}
              />
            </div>
            <div className=" flex-1 h-[calc(100vh-50vh)] overflow-scroll hideScroll  text-gray-500  flex flex-col pt-2  pb-4">
              {hospitalList.length > 0 && !isLoading && (
                <div className="flex flex-col gap-3 flex-wrap">
                  {hospitalList.map((hospital, index) => (
                    <div
                      className={`w-full flex flex-1 items-start space-x-3 py-4 px-2 bg-[#F5F5F5] text-[#32365C] rounded-[18px] border shadow cursor-pointer ${
                        tempSelectedHospital.some(
                          (selected) => selected.id === hospital.id
                        )
                          ? "border-primary"
                          : ""
                      }`}
                      key={index}
                      onClick={(e) => {
                        handleHospitalClick(hospital);
                      }}
                    >
                      <input
                        type="checkbox"
                        class="border-gray-300 rounded h-5 w-5 min-w-[20px] text-blue-500 bg-blue-100 focus:ring-blue-500 "
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent click event from bubbling to parent div
                          //  handleHospitalClick(hospital);
                        }}
                        checked={tempSelectedHospital.some(
                          (selected) => selected.id === hospital.id
                        )}
                        readOnly // Prevent checkbox from being editable by user
                      />

                      <div className="flex flex-col">
                        <div className="relative w-full">
                          <img
                            src={hospital?.logo_url}
                            alt={hospital?.name}
                            className="h-12 object-contain"
                          />
                        </div>
                        <h1 className="text-gray-700 font-medium leading-none">
                          {hospital.name}
                        </h1>
                        <p className="text-xs text-gray-500 mt-2 leading-4">
                          <span className="pr-2">
                            {hospital?.address?.street},
                          </span>
                          <span className="pr-2">
                            {hospital?.address?.city},
                          </span>
                          <span className="pr-2">
                            {hospital?.address?.state}
                          </span>
                          <span className="pr-2">
                            {hospital?.address?.postal_code}
                          </span>
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {hospitalList.length == 0 && !isLoading && (
                <h1 className="mt-4">No Hospitals found</h1>
              )}
              {isLoading && (
                <div className="flex flex-col gap-3 flex-wrap ">
                  {" "}
                  <div className="animate-pulse flex flex-row cursor-pointer p-4  w-full  items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                    <div className="w-full">
                      <div className="m-2 w-full  bg-slate-200 h-4"></div>
                    </div>
                  </div>
                  <div className="animate-pulse flex flex-row cursor-pointer p-4  w-full  items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                    <div className="w-full">
                      <div className="m-2 w-full  bg-slate-200 h-4"></div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div
              className="bg-white  w-full flex justify-center"
              onClick={updateHospitals}
            >
              <button className="  w-11/12  p-3 bg-blue-800 rounded-[18px] text-white font-semibold">
                Done
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <AlertDialog open={showDeleteConfirm} onOpenChange={setShowDeleteConfirm}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete</AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to remove {deleteItem?.name} from your
              profile.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={() => onDelete(deleteItem)}>
              Yes
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default AddFacilityPage;
